import { useRouter } from 'next/compat/router';

import useUI from 'shared/hooks/use-ui';
import { useDutchiePay } from 'src/payments/hooks';

import ROUTES from 'src/routes';
import { RouteParam } from 'src/types';
import { AccountRoutes } from '../account.types';
import { useDposLoyalty } from '../dpos-loyalty-context';

type UseAccountNavBarReturn = {
  isReady: boolean;
  accountRoutes: AccountRoutes | undefined;
  selectedTab: RouteParam;
  shouldDisplayDutchiePaySection: boolean;
  shouldDisplayLoyaltySection: boolean;
  shouldDisplayReferralsSection: boolean;
};

const { EMBEDDED_MENU, STORES } = ROUTES;

function buildAccountRoutes(
  cName: RouteParam,
  menuType: string,
  isReady: boolean,
  shouldDisplayLoyaltySection: boolean,
  shouldDisplayReferralsSection: boolean
): AccountRoutes | undefined {
  if (!isReady) {
    return undefined;
  }

  if (typeof cName !== 'string') {
    throw new Error(`ERROR: missing dispensary cName`);
  }

  return {
    account: `${menuType}/${cName}/user/account`,
    preferences: `${menuType}/${cName}/user/preferences`,
    orders: `${menuType}/${cName}/user/orders`,
    bankAccount: `${menuType}/${cName}/user/bank-account`,
    ...(shouldDisplayLoyaltySection
      ? {
          loyalty: `${menuType}/${cName}/user/loyalty`,
        }
      : {}),
    ...(shouldDisplayReferralsSection
      ? {
          referrals: `${menuType}/${cName}/user/referrals`,
        }
      : {}),
  };
}
export function useAccountNavBar(): UseAccountNavBarReturn {
  const { query: { cName, accountTab } = { cName: undefined, accountTab: undefined }, isReady } = useRouter() ?? {
    query: {},
    isReady: false,
  };

  const { isEmbedded } = useUI();
  const menuType = isEmbedded ? EMBEDDED_MENU : STORES;
  const { shouldShowBankAccountTab } = useDutchiePay();
  const { shouldDisplayLoyaltySection, shouldDisplayReferralsSection } = useDposLoyalty();
  const accountRoutes = buildAccountRoutes(
    cName,
    menuType,
    isReady,
    shouldDisplayLoyaltySection,
    shouldDisplayReferralsSection
  );
  const selectedTab: RouteParam = accountTab;

  return {
    isReady,
    accountRoutes,
    selectedTab,
    shouldDisplayDutchiePaySection: shouldShowBankAccountTab,
    shouldDisplayLoyaltySection,
    shouldDisplayReferralsSection,
  };
}
